import React, { useEffect } from "react";
import "./App.css";
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { Analytics } from '@vercel/analytics/react';
import { TimelineSection } from './components/TimelineSection';
import { VenueSection } from './components/VenueSection';
// import { StaySection } from './components/StaySection';
import { RSVPSection } from './components/RSVPSection';
import { GiftRegistrySection } from './components/GiftRegistrySection';
import { FooterSection } from './components/FooterSection';
import { Toaster } from './components/ui/sonner';

function App() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="App">
      <Analytics />
      <HeroSection />
      <StorySection />
      <TimelineSection />
      <VenueSection />
      {/* <StaySection /> */}
      <RSVPSection />
      <GiftRegistrySection />
      <FooterSection />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
